export default "__VITE_ASSET__f5abd4e4__"